'use client';

import { Content } from '@prismicio/client';

import { OptimizedPrismicImage } from '@/components';
import { useVisible } from '@/hooks';
import { memo } from 'react';
import Marquee from 'react-fast-marquee';
import { Simplify } from '../../../../prismicio-types';
import styles from './companiesListInner.module.scss';

interface CompaniesListInnerProps {
  data: Simplify<Content.CompaniesListSliceDefaultPrimary>;
}

const CompaniesListInnerComponent = ({ data }: CompaniesListInnerProps) => {
  const [isVisible, id] = useVisible();
  const isVisibleStyles = isVisible ? styles.isVisible : '';
  return (
    <div className={`${styles.wrapper} ${isVisibleStyles}`} id={id}>
      <p className={styles.heading}>{data.heading}</p>
      <article className={styles.list}>
        <Marquee speed={100} loop={0} gradient={false} className={styles.logos}>
          {data.companies.map((item) => (
            <OptimizedPrismicImage
              field={item.logo}
              className={styles.logo}
              key={item.logo.id}
            />
          ))}
        </Marquee>
      </article>
    </div>
  );
};

export const CompaniesListInner = memo(CompaniesListInnerComponent);
